export default class Token {
    constructor(data){
        this.accessToken = data.accessToken || undefined;
        this.refreshToken = data.refreshToken || undefined;
        this.expires = data.expires || undefined;
        this.userId = data.userId || undefined;
    }
}